import React, { useMemo, useState, useEffect } from "react";
import { useTable, useFilters, useSortBy, useGlobalFilter } from "react-table";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem } from "@material-ui/core";
import MenuIcon from "../reusableComponents/MenuIcon";
import "../../assets/stylesheets/patients.css";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import {
  downloadPrescription,
  resetDownloadPrescription,
  duplicatePrescription,
} from "../../redux/slices/prescription";
import { connect, useDispatch } from "react-redux";
import Alert from "react-bootstrap/Alert";
import { TbFileDownload } from "react-icons/tb";
import { Button } from "react-bootstrap";

const Component = ({
  id,
  prescription,
  prescriptions,
  isHomePatient,
  downloadLoading,
  downloadError,
  downloadSuccess,
  duplicateSuccess,
}) => {
  const dispatch = useDispatch();

  const hideAlert = () => {
    dispatch(resetDownloadPrescription());
  };

  const showAlert = useMemo(() => {
    console.log(
      "showAlert",
      !!(downloadLoading || downloadError || downloadSuccess)
    );
    return !!(downloadLoading || downloadError || downloadSuccess);
  }, [downloadLoading, downloadError, downloadSuccess]);

  const alertVariant = useMemo(() => {
    if (downloadError) {
      return "danger";
    } else if (downloadSuccess) {
      return "success";
    } else {
      return "light";
    }
  }, [downloadLoading, downloadError, downloadSuccess]);

  // translations
  const { t } = useTranslation();
  let currentLanguage = localStorage.getItem("i18nextLng");
  // utils
  const [filterInput, setFilterInput] = useState("");
  const [idPrescription, setIdPrescription] = useState(null);
  // menu
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = (event, item) => {
    setAnchorEl(event.currentTarget);
    setIdPrescription(item.id);
  };

  useEffect(() => {
    console.log();
    if (duplicateSuccess && !!prescription) {
      //const duplicatedPrescriptionUrl = `/prescription/${prescription?.id}?citation_id=${id}`;
      // window.location.href = duplicatedPrescriptionUrl;
      window.location.reload();
    }
  }, [prescription, duplicateSuccess]);

  const columns = useMemo(
    () => [
      {
        Header: " ",
        columns: [
          {
            Header: <>{t("PatientPrescriptions.Status")}</>,
            accessor: "state",
            Cell: (e) =>
              e.value === "issued" ? (
                <>{t("PrescriptionFormSelectors.State issued")}</>
              ) : e.value === "draft" ? (
                <>{t("PrescriptionFormSelectors.State draft")}</>
              ) : (
                <>
                  <span style={{ color: "#857c8e", fontStyle: "italic" }}>
                    {t("PrescriptionFormSelectors.State cancelled")}
                  </span>
                </>
              ),
          },
          {
            Header: <>{t("PatientPrescriptions.Date")}</>,
            accessor: "created_at",
            sortType: "basic",
            Cell: (e) => e.value.replace("T", "").slice(0, -13),
          },
          {
            Header: <>{t("PatientPrescriptions.Prescription No.")}</>,
            accessor: "prescription_id",
          },
          {
            Header: <>{t("PatientPrescriptions.Therapist")}</>,
            accessor: "doctor.name",
          },
          {
            Header: !isHomePatient ? " " : t("PatientInvoices.Download"),
            accessor: "id",
            Cell: ({ row }) =>
              !isHomePatient ? (
                <div style={{ paddingRight: "10px" }}>
                  <MenuIcon row={row} openMenu={openMenu} />
                </div>
              ) : (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    dispatch(
                      downloadPrescription({ idPrescription: row.original.id })
                    )
                  }
                >
                  <SaveAltIcon
                    className="patientInvoices-download-icon"
                    fontSize="small"
                  />
                </span>
              ),
          },
        ],
      },
    ],
    [currentLanguage]
  );

  const {
    getTableProps, // table props from react-table
    getTableBodyProps, // table body props from react-table
    headerGroups, // headerGroups, if your table has groupings
    prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
    setFilter, // The useFilter Hook provides a way to set the filter
    setGlobalFilter, // The useFilter Hook provides a way to set the filter
    rows, // rows OR PAGE for the table based on the data passed
    state: { globalFilter },
  } = useTable(
    {
      columns,
      data: prescriptions,
      initialState: {
        sortBy: [{ id: "created_at", desc: true }],
      },
    },
    useFilters,

    useGlobalFilter,
    useSortBy
  );

  React.useEffect(() => {}, [globalFilter]);

  return (
    <>
      <div
        style={{
          width: !isHomePatient ? "95%" : "100%",
          background: "white",
          paddingTop: "10px",
          scrollPaddingBottom: "10px",
          borderRadius: "8px",
          marginTop: !isHomePatient ? "0px" : "18px",
        }}
      >
        {!isHomePatient && (
          <div style={{ paddingLeft: "5px" }}>
            <input
              className="search-field"
              type="text"
              value={globalFilter || ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
              placeholder={t("ProducTable.0")}
            />
          </div>
        )}

        <table
          {...getTableProps()}
          className={`table table-striped ${
            !isHomePatient ? "table-borderless" : "tables responsive"
          }
          `}
        >
          <thead>
            {headerGroups.map((headerGroup, headerGroupIndex) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                key={`table-thead-tr-${headerGroupIndex}`}
              >
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row, rowsIndex) => {
              prepareRow(row);

              return (
                <tr {...row.getRowProps()} key={`table-tbody-tr-${rowsIndex}`}>
                  {row.cells.map((cell, rowCellsIndex) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        id={
                          "recent" + (rowCellsIndex + (!isHomePatient ? 1 : 0))
                        }
                        className="table-appointment-cell"
                        key={`table-tbody-tr-td-${rowCellsIndex}`}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        style={{ paddingLeft: "0px" }}
      >
        <Link
          to={{
            pathname: `/prescription/${idPrescription}`,
            search: `?patient_id=${id}`,
            state: { id: idPrescription, preview: true },
          }}
          onClick={() => setAnchorEl(null)}
          style={{ color: "#000", textDecoration: "none" }}
        >
          <MenuItem className="invoice-menu-item">
            <span className="invoice-menu-text">
              {t("PatientPrescriptions.View")}
            </span>
          </MenuItem>
        </Link>
        <Link
          to={{
            pathname: `/prescription/${idPrescription}`,
            search: `?patient_id=${id}`,
            state: { id: idPrescription },
          }}
          onClick={() => setAnchorEl(null)}
          style={{ color: "#000", textDecoration: "none" }}
        >
          <MenuItem className="invoice-menu-item">
            <span className="invoice-menu-text">
              {t("PatientPrescriptions.Edit")}
            </span>
          </MenuItem>
        </Link>
        <Button
          onClick={() => dispatch(downloadPrescription({ idPrescription }))}
          style={{
            color: "#000",
            textDecoration: "none",
            background: "none",
            padding: 0,
            border: 0,
          }}
        >
          <MenuItem className="invoice-menu-item">
            <span className="invoice-menu-text">
              {t("PatientPrescriptions.Download")}
            </span>
          </MenuItem>
        </Button>
        {/* <Link
          to={{
            pathname: `/prescription/${idPrescription}`,
            search: `?patient_id=${id}`,
            state: { id: idPrescription },
          }}
          onClick={() => setAnchorEl(null)}
          style={{ color: "#000", textDecoration: "none" }}
        > */}
        <Button
          onClick={() => dispatch(duplicatePrescription({ idPrescription }))}
          style={{
            color: "#000",
            textDecoration: "none",
            background: "none",
            padding: 0,
            border: 0,
          }}
        >
          <MenuItem className="invoice-menu-item">
            <span className="invoice-menu-text">
              {t("PatientPrescriptions.Duplicate")}
            </span>
          </MenuItem>
        </Button>
        {/* </Link> */}
      </Menu>
      <Alert
        position="bottom-end"
        show={showAlert}
        variant={alertVariant}
        style={{
          width: "300px",
          position: "fixed",
          bottom: 15,
          right: 15,
          left: "auto",
        }}
      >
        <Alert.Heading>
          <TbFileDownload />
          <strong className="me-auto" style={{ fontSize: 18 }}>
            {t("Messages.Downloading Prescription")}
          </strong>
        </Alert.Heading>
        <hr />
        <p>
          {downloadLoading &&
            t(
              "Messages.The prescription is preparing to being downloading, wait a moment please."
            )}
          {downloadError &&
            t(
              "Messages.An error occurred while trying to download the prescription."
            )}
          {downloadSuccess &&
            t("Messages.The prescription was download correctly.")}
        </p>
        {(downloadSuccess || downloadError) && (
          <div className="d-flex justify-content-start">
            <Button onClick={hideAlert} variant={alertVariant} size="sm">
              Close
            </Button>
          </div>
        )}
      </Alert>
    </>
  );
};

const state = ({ prescriptionStore }) => {
  const {
    loading: downloadLoading,
    error: downloadError,
    success: downloadSuccess,
  } = prescriptionStore.download;

  const {
    data: prescription,
    loading: duplicateLoading,
    error: duplicateError,
    success: duplicateSuccess,
  } = prescriptionStore.duplicate;

  return {
    downloadLoading,
    downloadError,
    downloadSuccess,
  };
};

export default connect(state)(Component);
